import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/global.css'
import './styles/global.css'

// 全局使用Element UI
Vue.use(ElementUI)

Vue.config.productionTip = false

// 创建Vue实例前，检查登录状态
store.dispatch('user/checkLoginStatus').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
